import { useMonitor } from '../use-monitor';

export function useMonitorEditIssueTemplateFormSubmit() {
  return useMonitor('edit-issue-template-form-submit');
}
